<template>
  <div>
    <FbMemberHeader
      :type="type"
      :member="group" />
    <v-container class="mb-10">
      <v-form>
        <!-- BASIC INFO -->
        <h1 class="caption text-uppercase">Basic Info</h1>
        <v-row wrap>
          <v-col cols="12" sm="6" lg="4">
            <v-text-field
              v-model.trim="group.name"
              label="Name"
              filled
              required
              hide-details
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" lg="4">
            <v-select
              v-model="groupType"
              :items="types"
              label="Group type"
              filled
              hide-details
            ></v-select>
          </v-col>

          <v-col cols="12" sm="6" lg="4">
            <v-text-field
              v-model.number="group.memberCount"
              label="Members"
              type="number"
              filled
              hide-details
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" lg="4">
            <v-checkbox
              v-model="group.isMember"
              label="Member"
              hide-details
            ></v-checkbox>
          </v-col>

          <v-col cols="12" sm="12">
            <v-textarea
              v-model="group.description"
              filled
              label="Description"
              counter="500"
              required
            ></v-textarea>
          </v-col>
        </v-row>
        <!-- PICTURES -->
        <FbMemberPictureGroup :member="group" />
      </v-form>
    </v-container>
  </div>
</template>

<script>
import FbMemberHeader from '../components/FbMemberHeader'
import FbMemberPictureGroup from '../components/FbMemberPictureGroup'

import { FbMember, FbGroup } from '../constants'
import { vueObjectAssign } from '../utils'

export default {
  name: 'FbGroup',
  injectModels: ['Store'],
  components: {
    FbMemberHeader,
    FbMemberPictureGroup
  },
  created() {
    this.id = this.$route.params.id
    this.group = this.Store.fb.groups[this.id]

    vueObjectAssign(this.group, {
      name: '',
      profilePicture: '',
      coverPicture: '',
      featurePictures: [],
      description: '',
      type: FbGroup.Public,
      memberCount: 0,
      isLiked: false
    })
  },
  data() {
    return {
      id: '',
      group: {},
      type: FbMember.Group,
      types: ['Public', 'Closed', 'Secret']
    }
  },
  computed: {
    groupType: {
      get() {
        return this.types[this.group.type]
      },
      set(type) {
        this.group.type = this.types.indexOf(type)
      }
    }
  }
}
</script>
